import { reactive, nextTick } from 'vue';
import { debounce } from "@/utils";
import {
    gantt,
} from "@/views/rdmanagement/components/customGantt/serve/taskProcess";

export const ganntConfig = reactive({
    list: [],
    calcHeight: 0
});

const flatArray = (list) => {
    const flatList = [];
    const ite = (list) => {
        list.forEach((item) => {
            flatList.push(item);

            if (item.children && item.children.length > 0) {
                ite(item.children);
            }
        });
    };
    ite(list);
    return flatList;
};

export const calcData = debounce((dom, tableList, expandedRowKeys) => {
    const list = flatArray(tableList);
    // 一条记录的高度
    // const oneRecordHeight = dom.scrollHeight / list.length;
    const oneRecordHeight = 93;
    // tbale差值的高度是
    const calcScrollTop =
        dom.scrollTop === 0
            ? 0
            : Number(dom.scrollTop / oneRecordHeight).toFixed(2);

    const startIndex = Math.floor(dom.scrollTop / oneRecordHeight);

    const endIndex = Math.ceil(
        (dom.scrollTop + dom.offsetHeight) / oneRecordHeight
    );

    const expandList = list.filter(
        (r) =>
            expandedRowKeys.findIndex((n) => n === r.pid) !== -1 ||
            r.pid === 0
    );

    // const showGanntList = expandList.slice(startIndex, endIndex);

    ganntConfig.list.length = 0;
    ganntConfig.calcHeight = calcScrollTop;
    ganntConfig.list.push(...expandList);
}, 100);

export const handelExpandGanntData = (list, expandedRowKeys) => {
    nextTick(() => {
        const dom = document.getElementsByClassName("ant-table-body")[0];
        calcData(dom, list, expandedRowKeys);
    });
};

export const setListener = (list, expandedRowKeys) => {
    nextTick(() => {
        const dom = document.getElementsByClassName("ant-table-body")[0];

        dom.addEventListener("scroll", (e) => {
            // calcData(dom, list, expandedRowKeys);
            if (gantt.value) {
                gantt.value.scrollTop = dom.scrollTop;
            }
        });
    })
};

export const setPrjectSchemeScroll = (scrollTop) => {
    const dom = document.getElementsByClassName("ant-table-body")[0];
    dom.scrollTop = scrollTop;
};
